module.exports = __webpack_public_path__ + "static/img/draw.a4787c19.png";